import * as React from 'react';

import {EmptyAddCard} from 'shells/card/empty-add-card';
import {LinkWithCopyButton} from 'shells/link/link-with-copy-button';

import type {SubdomainFragment as Subdomain} from 'nutshell-graphql-types';

import {DomainCard} from './domain-card';
import {DomainSidebar} from './domain-sidebar';

import styles from './hosting-section.module.css';

type Props = {
    customPublishedUrl: string | null | undefined;
    nutshellPublishedUrl: string;
    subdomainRecord: Subdomain | null | undefined;
    pageId: string;
    urlSlug: string;
};

export function HostingSection(props: Props) {
    const [isSidebarOpen, setIsSidebarOpen] = React.useState<boolean>(false);

    const openSidebar = () => setIsSidebarOpen(true);

    return (
        <>
            <div className={styles['hosting-section']}>
                {props.subdomainRecord ? (
                    <>
                        <DomainCard
                            link={
                                props.customPublishedUrl ||
                                // won't exist if domain is unverified, need to spoof it
                                `${props.subdomainRecord.formattedRecord}${props.urlSlug}`
                            }
                            onClickEdit={openSidebar}
                            isCustom={true}
                            isVerified={props.subdomainRecord && props.subdomainRecord.isVerified}
                        />
                        <div className={styles['nutshell-link-text']}>
                            <div>Also available at:</div>
                            <LinkWithCopyButton
                                link={props.nutshellPublishedUrl}
                                size='small'
                                shouldTruncate={true}
                            />
                        </div>
                    </>
                ) : (
                    <>
                        <DomainCard link={props.nutshellPublishedUrl} onClickEdit={openSidebar} />
                        <EmptyAddCard
                            onClick={openSidebar}
                            text='Use custom domain'
                            background='off-white'
                            size='small'
                            withoutIcon={true}
                            height={62}
                        />
                    </>
                )}
            </div>
            {isSidebarOpen && (
                <DomainSidebar
                    onClose={() => setIsSidebarOpen(false)}
                    pageId={props.pageId}
                    urlSlug={props.urlSlug}
                    subdomain={props.subdomainRecord}
                />
            )}
        </>
    );
}
